import { BoardTemplate } from './board-template.js'
import { BoardTemplateQuery } from './board-template-query.js'
import { BoardTemplateMutation } from './board-template-mutation.js'

export const entities = [BoardTemplate]
export const resolvers = [BoardTemplateQuery, BoardTemplateMutation]
export const subscribers = []
